import React from 'react'
import {ReactComponent as subOrder} from './subOrder.svg'
import Icon from '@ant-design/icons';

const IconSubOrder = () => {
    return <Icon component={subOrder}></Icon>
};

export default IconSubOrder